import React from 'react';
import { View } from 'react-native';

import { scale as initialScale } from '@components/frame';
import { isPhone as baseIsPhone } from '@helpers';

import NcFileContent from '@components/common/NCFile';
import { modalFieldBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { font as initialFont } from '@styles/fonts';

const NcFile = ({
  C,
  selectedItem,
  isPhone = baseIsPhone,
  showNcFileButtonCallBackOnPress,
  ncFileId,
  ncFileName,
  isOperatorPanel,
  isNcFileContentAvailable,
  shouldTakeNCFileDataFromMachine,
  scale = initialScale,
  font = initialFont,
}) => {
  const bg = modalFieldBg;
  return (
    <View
      style={[
        {
          width: '100%',
          flex: 1,
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          // backgroundColor: C(bg),
          // paddingTop: scale(15),
        },
      ]}
    >
      <NcFileContent
        {...{
          selectedItem,
          C,
          backgroundColor: C(bg),
          baseColor: C.scheme === 'dark' ? '10, 10, 10' : '243, 242, 248',
          showNcFileButtonCallBackOnPress,
          ncFileId,
          ncFileName,
          isOperatorPanel,
          isNcFileContentAvailable,
          shouldTakeNCFileDataFromMachine,
          scale,
          font,
        }}
      />
    </View>
  );
};

export default NcFile;
